/*----------------------------------
- TLD HUB CONTENT CATALOG (SSOT)
----------------------------------*/

/**
 * The words the rebuilt `/tld` hub adds on the marketing layer (batch 4 route 2, `docs/mockups/website-tld.html`): the
 * persona pair's labels and the newsletter band's submit. The board's words stay `TLD_PAGE_CONTENT.hub.board`, the
 * persona card's heading and body `TLD_PAGE_CONTENT.personas` (one wording with every insight page), the band's
 * heading and body the agenda's (`AGENDA_NEWSLETTER_BAND_CONTENT`).
 *
 * @docs docs/features/tld-intelligence
 */

import type { LandingSignupPersona } from '@/client/catalogs/landing/publicLinks';

/*----------------------------------
- CATALOG (SSOT)
----------------------------------*/

export const TLD_HUB_CONTENT = {
    /** As the mock and the shipped pair read them; the analytics label is `PERSONA_CTA_TRACKING_LABELS` whatever these say. */
    personaCtas: { investor: "I'm an Investor", founder: "I'm a Founder" } satisfies Record<LandingSignupPersona, string>,
    newsletter: { submit: 'Subscribe' },
} as const;
